import React from 'react';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';

function CheckboxGroup({ isSick, setIsSick, isVacation, setIsVacation }) {
  return (
    <>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isSick}
              onChange={(e) => setIsSick(e.target.checked)}
              name="isSick"
              color="primary"
            />
          }
          label="Sygedag"
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isVacation}
              onChange={(e) => setIsVacation(e.target.checked)}
              name="isVacation"
              color="primary"
            />
          }
          label="Feriedag"
        />
      </Grid>
    </>
  );
}

export default CheckboxGroup;